/**
 * Task 9.3 — the confirmation card for a suspended Confirm-tier tool call
 * (`tool_confirm_required`). This is the phase's acceptance gate: without
 * it, every MCP server and plugin tool (both default to Confirm tier) was
 * unusable from the UI — see CLAUDE.md "Phase 7 ... open items for Phase 9".
 */
import "./ConfirmCard.css";

interface Props {
  name: string;
  source: string;
  arguments: Record<string, unknown>;
  onApprove: () => void;
  /** Approve this call and skip the rest of this turn's confirmations. */
  onApproveAll?: () => void;
  onDeny: () => void;
  disabled?: boolean;
}

export default function ConfirmCard({
  name,
  source,
  arguments: args,
  onApprove,
  onApproveAll,
  onDeny,
  disabled,
}: Props) {
  return (
    <div className="confirm-card" role="alertdialog" aria-label={`Confirm tool call ${name}`}>
      <div className="confirm-card-header">
        <span className="confirm-card-icon">⚠️</span>
        <span className="confirm-card-title">Confirm tool call</span>
        <span className="tag tag-muted">{source}</span>
      </div>
      <div className="confirm-card-name">{name}</div>
      <pre className="confirm-card-args">{JSON.stringify(args, null, 2)}</pre>
      <div className="confirm-card-actions">
        <button
          className="btn btn-primary btn-sm"
          onClick={onApprove}
          disabled={disabled}
        >
          Approve
        </button>
        {onApproveAll && (
          <button
            className="btn btn-sm"
            onClick={onApproveAll}
            disabled={disabled}
            title="Approve this call and run the rest of this turn's tool calls without asking"
          >
            Approve all
          </button>
        )}
        <button
          className="btn btn-danger btn-sm"
          onClick={onDeny}
          disabled={disabled}
        >
          Deny
        </button>
      </div>
    </div>
  );
}
